module.exports = __webpack_public_path__ + "static/media/gb15.5cd14dff.png";